import src from "IMAGE";
export default { src, width: 512, height: 512, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAQElEQVR42q3LwQkAMAgDQO0Cdpc+WhzJV/d/NUIKDqBwIImKdMyADVYyY5adKBwImCyDmf6PXBwueS3r0SKVtnnsjAO0VZwU6QAAAABJRU5ErkJggg=="};
